import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
export const deleteRole = async (roleId) => {
  await authApiClient.delete(`/roles/${roleId}`);
};

export const useDeleteRoleHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { settings } = useTranslatedMessages();
  const teamSnacks = settings.team?.snackbar ?? {};

  const mutation = useMutation({
    mutationFn: deleteRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth-roles'] });
      dispatch(
        showSnackbar({
          message: teamSnacks.role_deleted || 'Role deleted successfully',
          severity: 'success',
        }),
      );
      onSuccess?.();
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : teamSnacks.role_delete_error || 'Failed to delete role';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
